import { createSlice } from '@reduxjs/toolkit'

const updatedOnSlice = createSlice({
  name: 'LTUpdatedOn',
  initialState: null, // Initial value of updatedOn
  reducers: {
    setLTUpdatedOn: (state, action) => action.payload
  }
})

export const { setLTUpdatedOn } = updatedOnSlice.actions

export default updatedOnSlice.reducer
